// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeMevo__contentWrap__OsybI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeMevo/ConsentTypeMevo.css
// module id = 3122
// module chunks = 0